export const BASE_CLASS = 'mt-FilterBasicLegacy'

export const NO_OP = () => {}
export const DEFAULT_EMPTY_OPTIONS = []
export const DEFAULT_EMPTY_SINGLE_VALUE = ''
export const DEFAULT_EMPTY_MULTIPLE_VALUE = []
